import React from "react";

export default function LoadingButton() {
  return (
    <div className="loadingio-spinner-interwind-o1710737tqc">
      <div className="ldio-sca6s4si7ee">
        <div>
          <div>
            <div>
              <div></div>
            </div>
          </div>
          <div>
            <div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
